import ChartsHelper from '@/helpers/charts';
import MetricsHelper from '@/helpers/metrics';
import types from './types';

export const state = {
  visitors: {},
  chart: {
    types: ChartsHelper.getChartsTypes(),
    data: [],
    colors: ChartsHelper.colors,
    keys: ChartsHelper.keys,
  },
};

const formatTime = (duration) => {
  let seconds = parseInt(duration % 60, 10);
  let minutes = parseInt((duration / 60) % 60, 10);
  let hours = parseInt((duration / (60 * 60)) % 24, 10);

  hours = (hours > 0) ? `${hours}h ` : '';
  minutes = (minutes > 0) ? `${minutes}min ` : '';
  seconds = (seconds > 0) ? `${seconds}s` : '~1s';

  return `${hours}${minutes}${seconds}`;
};

export const mutations = {
  [types.GET_METRICS](state, data) {
    if (!data.visitors) {
      return;
    }

    const visitors = data.visitors;

    state.visitors = visitors;
    state.visitors.uniquePercentage = MetricsHelper.percentage(visitors.unique, visitors.total);
    state.visitors.registeredEmailsPercentage = MetricsHelper.percentage(
      visitors.registered_emails, visitors.total,
    );

    state.visitors.devices.forEach((device) => {
      device.percentage = MetricsHelper.percentage(device.total, visitors.total);
    });

    state.visitors.clicks.forEach((click) => {
      click.percentage = MetricsHelper.percentage(click.conversions, visitors.total);
    });

    state.visitors.averageTimeElapsed = formatTime(visitors.average_time_elapsed);
  },
  [types.SET_CHART_DATA](state, { data, filters }) {
    data.forEach((metric) => {
      metric.period = ChartsHelper.formatPeriod(metric.period, filters.granularity);
    });

    state.chart.data = data;
  },
  [types.RESET_CHART_DATA](state) {
    state.chart.data = [];
  },
};



// WEBPACK FOOTER //
// ./src/screens/Metrics/store/mutations.js